<button [type]="type" [disabled]="isDisabled" class="w-full shadow py-2 px-4 rounded-md flex items-center justify-center gap-2 min-h-[40px] min-w-[140px]
         transition duration-150 ease-in-out
         text-white
         bg-primary hover:bg-primary-dark
         disabled:bg-primary/90 disabled:cursor-not-allowed relative">
  <svg *ngIf="loading" class="animate-spin h-5 w-5 text-white absolute" xmlns="http://www.w3.org/2000/svg" fill="none"
    viewBox="0 0 24 24">
    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
  </svg>
  <span [class.opacity-0]="loading">{{ text }}</span>
</button>
